
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3038',
  depVersions: {
  "customer-portal-app": "static-1.3038",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.494",
  "data-fetching-client": "static-1.9920",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26106",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5857",
  "hs-test-utils": "static-1.8291",
  "hub-http": "static-1.6476",
  "hub-http-shared-msw-handlers": "static-1.10552",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18900",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11746",
  "I18n": "static-7.1665",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6715",
  "payment-link-components": "static-1.24100",
  "portals-platform-bend-plugin": "static-1.19",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7399",
  "quartz-core": "static-1.6618",
  "quartz-i18n": "static-1.1074",
  "react": "static-7.191",
  "react-colorpicker": "static-2.10470",
  "react-dlb": "static-1.87",
  "react-utils": "static-2.5529",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20254",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18335",
  "ui-components-test-utils": "static-1.5883",
  "UIComponents": "static-3.8692",
  "foundations-assets": "static-1.5146",
  "foundations-components": "static-1.8422",
  "foundations-theming": "static-1.4730",
  "foundations-theming-specialty": "static-1.2446",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1373",
  "quartz-config": "static-1.1177",
  "quartz-routing": "static-1.829",
  "quick-fetch": "static-1.4106",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16974",
  "rpc-client-utils": "static-1.4925",
  "sanitize-text": "static-1.8414",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5018",
  "ui-addon-react-router-dom": "static-1.9800",
  "usage-tracker": "static-1.7619",
  "usage-tracker-anonymous": "static-1.6036",
  "usage-tracker-core": "static-1.7469",
  "video-components-external": "static-1.12088",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3676",
  "quartz-webpack": "static-1.3623",
  "bend-plugin-quartz-routing": "static-1.477",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7949",
  "frontend-preferences-client": "static-1.8188",
  "laboratory-lib": "static-3.7414",
  "onboarding-scopes": "static-1.6717",
  "seat-types-lib": "static-1.658",
  "ui-addon-opt": "static-4.8629",
  "HeadJS": "static-2.791",
  "hs-test-utils-bend-plugin": "static-1.3402",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.268",
  "ts-schema": "static-1.4269",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8151",
  "content-media-capture": "static-1.5354",
  "cssUtils": "static-1.880",
  "customer-data-ui-utilities": "static-1.10090",
  "file-manager-components": "static-1.24399",
  "HubStyle": "static-2.12053",
  "knowledge-content-types": "static-1.8629",
  "PatternValidationJS": "static-1.3159",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.497",
  "ui-addon-emoji-picker": "static-1.10148",
  "ui-addon-i18n": "static-1.11406",
  "ui-business-units-lib": "static-1.9346",
  "ui-shepherd-react": "static-3.10528",
  "video-data-lib": "static-1.35746",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4578",
  "commerce-tours-lib": "static-1.6557",
  "customer-data-properties": "static-1.52476",
  "getting-started-shared-tasks": "static-1.19151",
  "growth-onboarding-reliability": "static-1.5343",
  "onboarding-tours": "static-1.17063",
  "reference-resolvers-lite": "static-1.8363",
  "sales-checkout-service-client": "static-1.3790",
  "ui-addon-iframeable": "static-1.9336",
  "user-context": "static-1.5380",
  "bender-build-tools": "static-1.3401",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4838",
  "icons": "static-2.675",
  "mobile-manifest-mixins": "static-1.571",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.407",
  "quartz-auth": "static-1.1074",
  "quartz-head": "static-1.1064",
  "quartz-test": "static-1.1074",
  "quartz-tracking": "static-1.778",
  "trellis-components": "static-1.2546",
  "ui-fonts": "static-1.1008",
  "usage-tracker-container": "static-1.7609",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9689",
  "data-token-picker": "static-1.16836",
  "FileManagerLib": "static-1.40039",
  "property-translator": "static-1.5660",
  "atom": "static-1.5348",
  "merchandise-lib": "static-1.275",
  "purchase-motions-components": "static-1.6301",
  "salesImages": "static-1.532",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5905",
  "react-create-root-preference": "static-1.64",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1234",
  "bend-plugin-foundations-components": "static-1.4691",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2527",
  "bend-plugin-foundations-theming": "static-1.3213",
  "foundations-theming-base": "static-1.3715",
  "stylex": "static-1.38",
  "interframe": "static-3.5018",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6033",
  "opentelemetry-fe-types": "static-1.32",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.335",
  "chirp-fetch": "static-1.2156",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4738",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4918",
  "content-media-composition-data-lib": "static-1.13158",
  "content-media-compositions": "static-2.17165",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4413",
  "magpie-lib": "static-1.5728",
  "magpie-types": "static-1.5188",
  "media-bridge-lib": "static-1.19355",
  "inbound-db-properties-service-client": "static-1.4032",
  "superstore": "static-1.5019",
  "feedback-loader": "static-1.29755",
  "ai-components-ui-library": "static-1.9630",
  "ui-addon-video-player": "static-1.8965",
  "ui-coaching-tips": "static-1.29244",
  "ContentUtils": "static-1.69063",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4689",
  "sassPrefix": "static-1.163",
  "react-dnd-compat": "static-1.4878",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1613",
  "copilot-toolkit": "static-1.11776",
  "avatar-components": "static-1.2757",
  "navigation-messaging": "static-1.8068",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8442",
  "commerce-products-lib": "static-1.10448",
  "crm-message-bus": "static-1.43675",
  "growth-data-modal": "static-1.5840",
  "hubspot-apollo-client": "static-1.5141",
  "onboarding-tours-client": "static-1.5277",
  "batch-promise": "static-1.1804",
  "calling-global-api": "static-1.65446",
  "calling-internal-common": "static-1.31580",
  "calling-lifecycle-internal": "static-1.66828",
  "calling-lifecycle-messages": "static-1.59122",
  "conditional-properties-service-client": "static-1.3987",
  "crm-index-visualization-core": "static-1.4493",
  "crm-links": "static-1.6589",
  "crm-pipelines-api-client-types": "static-1.4323",
  "customer-data-objects-ui-components": "static-1.13291",
  "customer-data-properties-shared-msw-handlers": "static-1.9879",
  "customer-data-property-utils": "static-1.8361",
  "external-options-client-types": "static-1.4315",
  "formula-editor": "static-1.14695",
  "framework-data-schema-resolvers": "static-1.7155",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.454",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4400",
  "meetings-icalendar-utils-lib": "static-1.898",
  "multi-currency-client-types": "static-1.3884",
  "object-builder-ui-client": "static-1.49579",
  "pipeline-validation-client-types": "static-1.4157",
  "property-value-citations": "static-1.3090",
  "pulse": "static-1.887",
  "smart-data-capture-core": "static-1.58",
  "smart-property-lib": "static-1.8207",
  "tiered-pricing": "static-1.1895",
  "topics-actions-lib": "static-1.428",
  "trial-components-library": "static-1.14046",
  "ui-addon-form-validation": "static-1.11248",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3325",
  "growth-onboarding-next-action-utils": "static-1.2626",
  "navigation-components": "static-1.18741",
  "onboarding-tours-utils": "static-1.1129",
  "ui-shepherd-tracker": "static-1.7909",
  "ui-universal-auth": "static-1.9323",
  "getting-started-shared-tasks-store": "static-1.18269",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10550",
  "usage-tracker-session-replay": "static-1.5305",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1229",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6291",
  "FileManagerCore": "static-1.39898",
  "FileManagerImages": "static-1.37550",
  "video-components": "static-1.14090",
  "foundations-components-legacy": "static-1.1447",
  "purchase-motions-api": "static-1.6304",
  "signup-constants": "static-1.19539",
  "signup-ui-url-generator": "static-2.8322",
  "usage-tracker-public": "static-1.7430",
  "reactive-lib": "static-1.983",
  "simple-logging-lib": "static-1.3313",
  "chatspot-core": "static-1.22733",
  "growth-onboarding-feedback-components": "static-1.6846",
  "cms-field-types": "static-1.5077",
  "content-icons-ui": "static-1.2326",
  "integrations-lib": "static-1.16961",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.591",
  "breeze-engine-core": "static-1.891",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1039",
  "customer-data-tracking": "static-1.7143",
  "products-iframe-lib": "static-1.8522",
  "products-ui-components-shared-msw-handlers": "static-1.10934",
  "restore-request-side-panel-lib": "static-1.1593",
  "onboarding-data-sync-lib": "static-1.2440",
  "hubspot-apollo-cache": "static-1.600",
  "calling-error-reporting": "static-1.31587",
  "shared-worker-versioning": "static-1.11302",
  "calling-usage-tracker": "static-1.6800",
  "voice-sms-access-library": "static-1.1949",
  "conversations-skeleton-state": "static-1.7512",
  "crm-index-associations-lib": "static-1.6705",
  "framework-data-schema-quick-fetch": "static-1.7060",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10635",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4518",
  "location-customization-utils-lib": "static-1.10022",
  "bark-lib": "static-1.16769",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6152",
  "react-codemirror": "static-1.10901",
  "fdsr-migration-layer": "static-1.274",
  "framework-builder-read-service-client": "static-1.4197",
  "persist-promise": "static-1.3961",
  "event-emitter": "static-1.1216",
  "bend-plugin-pulse": "static-1.390",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.593",
  "fsm": "static-1.4004",
  "policy-lib": "static-1.7059",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10698",
  "embedded-academy-lib": "static-1.15410",
  "hubs-service-types": "static-1.1521",
  "growth-onboarding-next-action-components": "static-1.2654",
  "user-context-client": "static-1.4771",
  "nest": "static-1.498",
  "unified-auth-core-lib": "static-1.1119",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.227",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4795",
  "video-embed": "static-1.36580",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.362",
  "integrations-error-boundary-lib": "static-1.14376",
  "integrations-tracking-lib": "static-1.5870",
  "native-integrations-shared-strings": "static-1.8040",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10631",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.837",
  "InboxConnectUtils": "static-4.15485",
  "meetings-connect-utils-lib": "static-1.7872",
  "calling-orchestration-schema": "static-1.36726",
  "crm-record-cards-service-types": "static-1.3759",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16295",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4773",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14870",
  "outpost": "static-1.4422",
  "universal-page-editor-lib": "static-1.3270",
  "adobe-sign-auth-lib": "static-1.384",
  "ads-unified-auth-lib": "static-1.1161",
  "google-sheets-integration-lib": "static-1.960",
  "microsoft-drive-auth-lib": "static-1.57",
  "surveymonkey-integration-lib": "static-1.403",
  "slack-ui-library": "static-1.10661",
  "hub-http-contrib": "static-1.3300",
  "ui-addon-sales-email": "static-1.5477",
  "academy-service-client": "static-1.3951",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4667",
  "trellis-ecosystem": "static-1.7580",
  "wootric-nps": "static-1.7175",
  "marketplace-ui-apps-core": "static-1.19169",
  "marketplace-ui-common": "static-1.20637",
  "developer-experience-shared-components": "static-1.10766",
  "immutable-less": "static-1.4913",
  "marketplace-ui-client-types": "static-1.18044",
  "ui-addon-integrations-directory-panel": "static-2.8288",
  "ui-extensibility-client-types": "static-1.4182",
  "ai-settings-ui-library": "static-1.8274",
  "nav-meta": "static-1.30378",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.921",
  "apps-service-types": "static-1.4003",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3465"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3038",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.494",
  "data-fetching-client": "/data-fetching-client/static-1.9920",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26106",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5857",
  "hs-test-utils": "/hs-test-utils/static-1.8291",
  "hub-http": "/hub-http/static-1.6476",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10552",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18900",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11746",
  "I18n": "/I18n/static-7.1665",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6715",
  "payment-link-components": "/payment-link-components/static-1.24100",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.19",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7399",
  "quartz-core": "/quartz-core/static-1.6618",
  "quartz-i18n": "/quartz-i18n/static-1.1074",
  "react": "/react/static-7.191",
  "react-colorpicker": "/react-colorpicker/static-2.10470",
  "react-dlb": "/react-dlb/static-1.87",
  "react-utils": "/react-utils/static-2.5529",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20254",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18335",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5883",
  "UIComponents": "/UIComponents/static-3.8692",
  "foundations-assets": "/foundations-assets/static-1.5146",
  "foundations-components": "/foundations-components/static-1.8422",
  "foundations-theming": "/foundations-theming/static-1.4730",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2446",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1373",
  "quartz-config": "/quartz-config/static-1.1177",
  "quartz-routing": "/quartz-routing/static-1.829",
  "quick-fetch": "/quick-fetch/static-1.4106",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16974",
  "rpc-client-utils": "/rpc-client-utils/static-1.4925",
  "sanitize-text": "/sanitize-text/static-1.8414",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5018",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9800",
  "usage-tracker": "/usage-tracker/static-1.7619",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6036",
  "usage-tracker-core": "/usage-tracker-core/static-1.7469",
  "video-components-external": "/video-components-external/static-1.12088",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3676",
  "quartz-webpack": "/quartz-webpack/static-1.3623",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.477",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7949",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8188",
  "laboratory-lib": "/laboratory-lib/static-3.7414",
  "onboarding-scopes": "/onboarding-scopes/static-1.6717",
  "seat-types-lib": "/seat-types-lib/static-1.658",
  "ui-addon-opt": "/ui-addon-opt/static-4.8629",
  "HeadJS": "/HeadJS/static-2.791",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3402",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.268",
  "ts-schema": "/ts-schema/static-1.4269",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8151",
  "content-media-capture": "/content-media-capture/static-1.5354",
  "cssUtils": "/cssUtils/static-1.880",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10090",
  "file-manager-components": "/file-manager-components/static-1.24399",
  "HubStyle": "/HubStyle/static-2.12053",
  "knowledge-content-types": "/knowledge-content-types/static-1.8629",
  "PatternValidationJS": "/PatternValidationJS/static-1.3159",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10148",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11406",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9346",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10528",
  "video-data-lib": "/video-data-lib/static-1.35746",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4578",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6557",
  "customer-data-properties": "/customer-data-properties/static-1.52476",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19151",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5343",
  "onboarding-tours": "/onboarding-tours/static-1.17063",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8363",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3790",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9336",
  "user-context": "/user-context/static-1.5380",
  "bender-build-tools": "/bender-build-tools/static-1.3401",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4838",
  "icons": "/icons/static-2.675",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.571",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.407",
  "quartz-auth": "/quartz-auth/static-1.1074",
  "quartz-head": "/quartz-head/static-1.1064",
  "quartz-test": "/quartz-test/static-1.1074",
  "quartz-tracking": "/quartz-tracking/static-1.778",
  "trellis-components": "/trellis-components/static-1.2546",
  "ui-fonts": "/ui-fonts/static-1.1008",
  "usage-tracker-container": "/usage-tracker-container/static-1.7609",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9689",
  "data-token-picker": "/data-token-picker/static-1.16836",
  "FileManagerLib": "/FileManagerLib/static-1.40039",
  "property-translator": "/property-translator/static-1.5660",
  "atom": "/atom/static-1.5348",
  "merchandise-lib": "/merchandise-lib/static-1.275",
  "purchase-motions-components": "/purchase-motions-components/static-1.6301",
  "salesImages": "/salesImages/static-1.532",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5905",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1234",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4691",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2527",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3213",
  "foundations-theming-base": "/foundations-theming-base/static-1.3715",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5018",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6033",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.32",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.335",
  "chirp-fetch": "/chirp-fetch/static-1.2156",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4738",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4918",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13158",
  "content-media-compositions": "/content-media-compositions/static-2.17165",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4413",
  "magpie-lib": "/magpie-lib/static-1.5728",
  "magpie-types": "/magpie-types/static-1.5188",
  "media-bridge-lib": "/media-bridge-lib/static-1.19355",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4032",
  "superstore": "/superstore/static-1.5019",
  "feedback-loader": "/feedback-loader/static-1.29755",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9630",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8965",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29244",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4689",
  "sassPrefix": "/sassPrefix/static-1.163",
  "react-dnd-compat": "/react-dnd-compat/static-1.4878",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1613",
  "copilot-toolkit": "/copilot-toolkit/static-1.11776",
  "avatar-components": "/avatar-components/static-1.2757",
  "navigation-messaging": "/navigation-messaging/static-1.8068",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8442",
  "commerce-products-lib": "/commerce-products-lib/static-1.10448",
  "crm-message-bus": "/crm-message-bus/static-1.43675",
  "growth-data-modal": "/growth-data-modal/static-1.5840",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5141",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5277",
  "batch-promise": "/batch-promise/static-1.1804",
  "calling-global-api": "/calling-global-api/static-1.65446",
  "calling-internal-common": "/calling-internal-common/static-1.31580",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66828",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59122",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3987",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4493",
  "crm-links": "/crm-links/static-1.6589",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4323",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13291",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9879",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8361",
  "external-options-client-types": "/external-options-client-types/static-1.4315",
  "formula-editor": "/formula-editor/static-1.14695",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7155",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.454",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4400",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.898",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3884",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49579",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4157",
  "property-value-citations": "/property-value-citations/static-1.3090",
  "pulse": "/pulse/static-1.887",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.58",
  "smart-property-lib": "/smart-property-lib/static-1.8207",
  "tiered-pricing": "/tiered-pricing/static-1.1895",
  "topics-actions-lib": "/topics-actions-lib/static-1.428",
  "trial-components-library": "/trial-components-library/static-1.14046",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3325",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2626",
  "navigation-components": "/navigation-components/static-1.18741",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1129",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7909",
  "ui-universal-auth": "/ui-universal-auth/static-1.9323",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18269",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10550",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5305",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1229",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6291",
  "FileManagerCore": "/FileManagerCore/static-1.39898",
  "FileManagerImages": "/FileManagerImages/static-1.37550",
  "video-components": "/video-components/static-1.14090",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1447",
  "purchase-motions-api": "/purchase-motions-api/static-1.6304",
  "signup-constants": "/signup-constants/static-1.19539",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8322",
  "usage-tracker-public": "/usage-tracker-public/static-1.7430",
  "reactive-lib": "/reactive-lib/static-1.983",
  "simple-logging-lib": "/simple-logging-lib/static-1.3313",
  "chatspot-core": "/chatspot-core/static-1.22733",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6846",
  "cms-field-types": "/cms-field-types/static-1.5077",
  "content-icons-ui": "/content-icons-ui/static-1.2326",
  "integrations-lib": "/integrations-lib/static-1.16961",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.591",
  "breeze-engine-core": "/breeze-engine-core/static-1.891",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1039",
  "customer-data-tracking": "/customer-data-tracking/static-1.7143",
  "products-iframe-lib": "/products-iframe-lib/static-1.8522",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10934",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1593",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2440",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.600",
  "calling-error-reporting": "/calling-error-reporting/static-1.31587",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11302",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6800",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1949",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6705",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7060",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10635",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4518",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10022",
  "bark-lib": "/bark-lib/static-1.16769",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6152",
  "react-codemirror": "/react-codemirror/static-1.10901",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.274",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4197",
  "persist-promise": "/persist-promise/static-1.3961",
  "event-emitter": "/event-emitter/static-1.1216",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.390",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.593",
  "fsm": "/fsm/static-1.4004",
  "policy-lib": "/policy-lib/static-1.7059",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10698",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15410",
  "hubs-service-types": "/hubs-service-types/static-1.1521",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2654",
  "user-context-client": "/user-context-client/static-1.4771",
  "nest": "/nest/static-1.498",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1119",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.227",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4795",
  "video-embed": "/video-embed/static-1.36580",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.362",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14376",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5870",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8040",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10631",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.837",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15485",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7872",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36726",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16295",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4773",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14870",
  "outpost": "/outpost/static-1.4422",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3270",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.384",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1161",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.960",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.57",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.403",
  "slack-ui-library": "/slack-ui-library/static-1.10661",
  "hub-http-contrib": "/hub-http-contrib/static-1.3300",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5477",
  "academy-service-client": "/academy-service-client/static-1.3951",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4667",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7580",
  "wootric-nps": "/wootric-nps/static-1.7175",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19169",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20637",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10766",
  "immutable-less": "/immutable-less/static-1.4913",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18044",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8288",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4182",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8274",
  "nav-meta": "/nav-meta/static-1.30378",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.921",
  "apps-service-types": "/apps-service-types/static-1.4003",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3465"
}
};
